import {
  FormInput,
  validateEmail,
  validateNumbers,
  validatePhoneNumber,
  validateRequired,
} from 'components/shared/Forms/ReduxForm'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Button, Form, Grid, Icon } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch)
}

class AddressEditor extends React.Component {
  render() {
    const { initialized, destroy, handleSubmit } = this.props
    const { changeAddress } = this.props

    return !initialized ? null : (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={12} textAlign="right">
            <Icon
              link
              color="red"
              name="close"
              size="large"
              onClick={() => destroy()}
            />
          </Grid.Column>
          <Grid.Column width={12}>
            <Form>
              <Field
                component={FormInput}
                fluid
                name="address1"
                label={I18n.t('form.address1')}
                validate={validateRequired}
              />

              <Field
                component={FormInput}
                fluid
                name="address2"
                label={I18n.t('form.address2')}
              />

              <Field
                component={FormInput}
                fluid
                name="address3"
                label={I18n.t('form.address3')}
              />

              <Form.Group>
                <Field
                  component={FormInput}
                  fluid
                  width={4}
                  name="postcode"
                  label={I18n.t('form.postcode')}
                  validate={[validateRequired, validateNumbers]}
                />
                <Field
                  component={FormInput}
                  fluid
                  width={8}
                  name="place"
                  label={I18n.t('form.place')}
                  validate={validateRequired}
                />
              </Form.Group>

              <Form.Group>
                <Field
                  width={6}
                  component={FormInput}
                  fluid
                  name="phone"
                  label={I18n.t('form.phone')}
                  validate={validatePhoneNumber}
                />
                <Field
                  width={6}
                  component={FormInput}
                  fluid
                  name="fax"
                  label={I18n.t('form.fax')}
                  validate={validatePhoneNumber}
                />
              </Form.Group>

              <Field
                component={FormInput}
                fluid
                name="email"
                label={I18n.t('form.email')}
                validate={[validateRequired, validateEmail]}
              />

              <Button.Group>
                <Button
                  icon="save"
                  primary
                  content={I18n.t('global.save')}
                  onClick={handleSubmit((formValues) => {
                    changeAddress(formValues)
                    destroy()
                  })}
                />
              </Button.Group>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

AddressEditor = connect(mapStateToProps, mapDispatchToProps)(AddressEditor)
AddressEditor = reduxForm({ form: 'address-editor' })(AddressEditor)
export default AddressEditor



// WEBPACK FOOTER //
// ./src/components/shared/Addresses/AddressEditor.jsx